import { createSelector } from "@ngrx/store";
import { SignedInUserState } from './signed-in-user.reducer';

export interface MainState {
  signedInUser: SignedInUserState;
}

const getSignedInUserState = (state: MainState) => state.signedInUser;

export const selectSignedInUser = createSelector(getSignedInUserState, (userState) => userState.user);

export const signedInUserSelectors = { selectSignedInUser };